export default "__VITE_ASSET__BUxJ1Fky__"